import gql from 'graphql-tag';

export const GET_CUSTOMER_DOCUMENTS = gql`
  query GetCustomerDocuments($customerAccountId: ID!) {
    customer {
      customerDocuments(customerAccountId: $customerAccountId) {
        error
        success
        list {
          customerAccountName

          document {
            documentId
            vendorOpportunityId
            source
            viewUrl
            docType
            docDescription
            createdBy
            docName
            createdDateTime
            createdByAccount
          }

          task {
            taskId
            regarding
          }
        }
      }
    }
  }
`;
